export const isOverflown = ({
  clientWidth, clientHeight, scrollWidth, scrollHeight,
} = {}) => scrollHeight && (scrollHeight > clientHeight || scrollWidth > clientWidth);
